import React from "react";

const Container = ({ children, customClassName}) => (
  <div className={`container ${customClassName ? customClassName : ""}`}>
    {children}
  </div>
);

export default Container;



// WEBPACK FOOTER //
// ./src/components/container.js